import { FeaturedItemsCardViewModel } from '@/view-models/FeaturedItemsCardViewModel'
import Link from '@/components/Link/Link'
import cx from 'classnames'
import styles from './contentCard-style.css'
import Image from '@/components/Image/Image'
import Heading from '@/components/Heading/Heading'
import ArrowRightIcon from '@/icons/ArrowRightIcon'
import Paragraph from '@/components/Paragraph/Paragraph'
import * as React from 'react'

export const ContentCard = ({
  title,
  text,
  link,
  image,
  className,
  date,
  eventName,
  showDate = true,
}: FeaturedItemsCardViewModel) => {
  return (
    <Link
      {...link}
      className={cx(styles.card, className)}
      eventMeta={{ event: eventName }}
    >
      {image && (
        <div className={styles.cardImageWrapper}>
          <Image {...image} fill={true} className={styles.cardImage} />
        </div>
      )}

      <div className={styles.cardContent}>
        <div className={styles.cardHeaderWrapper}>
          <Heading className={styles.cardTitle} level={4} tag={'h4'}>
            {title}
          </Heading>

          <div className={styles.cardIcon}>
            <ArrowRightIcon width={'16'} height={'16'} />
          </div>
        </div>

        <Paragraph className={styles.cardExcerpt} weight={'light'}>
          {text}
        </Paragraph>

        {date && showDate && (
          <Paragraph className={styles.cardDate} weight={'light'} tag={'span'}>
            {date}
          </Paragraph>
        )}
      </div>
    </Link>
  )
}
